import { render, staticRenderFns } from "./SystemsMessageAlert.vue?vue&type=template&id=500e4735&"
import script from "./SystemsMessageAlert.vue?vue&type=script&lang=js&"
export * from "./SystemsMessageAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports